/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getReport.defs.js'
export { main as default } from './getReport.defs.js'
